import React from 'react'
import { DataTableFiltersState, NestedDataTableState } from '../../../../shared/components/DataTable'
import { LinkedRecordsPanel } from '../../../../shared/components/LinkedRecordsPanel'
import useValueMessageDisplayName from '../../../../shared/hooks/useDisplayNames/variants/useValueMessageDisplayName'
import { useGetValueNarrativesQuery } from '../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'
import { getValueMessageColumns } from '../ValueMessageTable.columns'
import { DEFAULT_VALUE_MESSAGE_COLUMN_IDS, getValueMessagePath } from '../ValueMessageTable.constants'
import { getValueMessageFilterDefinitions, getValueMessageSearchValues } from '../ValueMessageTable.filters'
import { ValueMessageColumnId } from '../ValueMessageTable.types'
import { useValueMessageDisplayNames } from '../useValueMessageDisplayNames'
import { useValueMessageRows } from '../useValueMessageRows'
import { renderValueMessageCell } from './renderValueMessageCell'

type LinkedValueMessagesPanelProps = {
    ownerName: string
    ownerLabel: string
    linkedIds: string[] | undefined
    filtersState: DataTableFiltersState
    state: NestedDataTableState<ValueMessageColumnId>
}

export const LinkedValueMessagesPanel = ({
    ownerName,
    ownerLabel,
    linkedIds,
    filtersState,
    state,
}: LinkedValueMessagesPanelProps) => {
    const valueMessageDisplayNames = useValueMessageDisplayNames()
    const valueMessageDisplayName = useValueMessageDisplayName()
    const valueNarrativesQuery = useGetValueNarrativesQuery()
    const valueMessageRows = useValueMessageRows(valueNarrativesQuery.data)

    return (
        <LinkedRecordsPanel
            ownerName={ownerName}
            ownerLabel={ownerLabel}
            recordsQuery={valueNarrativesQuery}
            records={valueMessageRows}
            linkedIds={linkedIds}
            recordDisplayName={valueMessageDisplayName}
            columns={getValueMessageColumns(valueMessageDisplayNames)}
            filterDefinitions={getValueMessageFilterDefinitions(
                valueMessageDisplayNames,
                DEFAULT_VALUE_MESSAGE_COLUMN_IDS
            )}
            getSearchValues={getValueMessageSearchValues}
            renderCell={renderValueMessageCell}
            getRecordName={(valueMessage) => valueMessage.name}
            getRecordPath={getValueMessagePath}
            filtersState={filtersState}
            state={state}
        />
    )
}

export default LinkedValueMessagesPanel
